import React, { Component } from 'react'
import { connect } from 'react-redux'
import './index.scss'

import AnimationCount from 'react-count-animation'

import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class TemplatesArea extends Component {
    fixedTemplatesEn = {
        "병원/전문직": [
            {
                "_id": "6257e533e13c400033ac3bd1",
                "name": "Introducing Simple Stores"
            },
            {
                "_id": "6257e5c3e13c400033ac3bed",
                "name": "Introducing Simple Stores3"
            },
            {
                "_id": "5f68336969d7e9005d660d36",
                "name": "Simple hospital ad"
            },
            {
                "_id": "5f7ec027f67f8c002da0bbe7",
                "name": "The breeze dots"
            }
        ],
        "부동산": [
            {
                "_id": "61441e7d18eb4f03bca2a80b",
                "name": "Calm photo ad"
            },
            {
                "_id": "60094e21f7a9f0002dac0981",
                "name": "Red Flyer"
            },
            {
                "_id": "5fe43112c2a2220b66a78970",
                "name": "Simple business AD"
            },
            {
                "_id": "61ca70e6f9eb0e054d3816b3",
                "name": "play button promo"
            }
        ],
        "뷰티": [
            {
                "_id": "6231d4dc590309002c333f01",
                "name": "Blue White ad"
            },
            {
                "_id": "6243bff47388421fb816db80",
                "name": "Blue rhythmical ad"
            },
            {
                "_id": "607919772e7352121fffc1cf",
                "name": "Healthy choice"
            },
            {
                "_id": "608bbc1defd143003423489b",
                "name": "Time to care for me"
            }
        ],
        "E커머스/쇼핑몰": [
            {
                "_id": "60388da954f944002d3e52b8",
                "name": "Introducing the yellow sale"
            },
            {
                "_id": "61d7e829ce89f6002d1dbb34",
                "name": "Pale Text ad"
            },
            {
                "_id": "6156cd1c8b73ca0d20207cea",
                "name": "Perspective moving typo"
            },
            {
                "_id": "624aab29d1a60b17bc7a1161",
                "name": "Pink Beauty Promotion"
            },
            {
                "_id": "61160efff1a96f013dca8622",
                "name": "Simple shopping event"
            },
            {
                "_id": "60e81e185699c22b1f839cb9",
                "name": "a welcoming ambience"
            }
        ],
        "숙박/여행/레저": [
            {
                "_id": "602f57a39ba5333d093cfe91",
                "name": "4cut-log 169"
            },
            {
                "_id": "625cf14958606f0fb964af27",
                "name": "Noise Film Photo"
            },
            {
                "_id": "61ef5d7d001cae004f8e857a",
                "name": "Photo feed vlog"
            },
            {
                "_id": "60f13ab2d1104d002cd5cb57",
                "name": "cozy summer holidays"
            }
        ],
        "카페/음식/베이커리": [
            {
                "_id": "61d7e4d867762a0388b9d814",
                "name": "4cut-log 207"
            },
            {
                "_id": "6226e72a98c4ef002c5b3b63",
                "name": "4cut-log 220"
            },
            {
                "_id": "60f92d11b8a60a031fbaa24a",
                "name": "4cut-log 223"
            },
            {
                "_id": "60a7594536fa57002ded6cf1",
                "name": "Cup of coffee"
            },
            {
                "_id": "6082432f4a60010034aa21ef",
                "name": "Pink macaroons Title"
            },
            {
                "_id": "610cde52ae9a2a012ac74ed9",
                "name": "Simple Coffee Ad"
            },
            {
                "_id": "5de50230477d410047a70927",
                "name": "emotional cafe"
            }
        ],
        "패션": [
            {
                "_id": "616002049f8f070494336877",
                "name": "Fall fashion shopping"
            },
            {
                "_id": "6094d1cef8da150034e2b26f",
                "name": "It suits your daily look!"
            },
            {
                "_id": "6258fc7f275b4a06043939a2",
                "name": "Neon Dynamic Glitch ad"
            },
            {
                "_id": "619f49e153d3760b3ac38b7e",
                "name": "On the beach"
            },
            {
                "_id": "6221b6df174d1f0765babcd0",
                "name": "Rainbow Typo ad"
            },
            {
                "_id": "620f24df048951002c4b0492",
                "name": "Vivid Brand ad"
            },
            {
                "_id": "60c346b593dbd6002cf1f30b",
                "name": "at any time you want"
            }
        ],
        "헬스/스포츠": [
            {
                "_id": "61c55860485d04063d6e62a3",
                "name": "Black&White Sporty ad"
            },
            {
                "_id": "6116390852a3680270d74fad",
                "name": "Cinematic trailer"
            },
            {
                "_id": "5fc9f7289ea3410034edba6d",
                "name": "Neon Effect"
            },
            {
                "_id": "6253b4f91bcb9e0953589673",
                "name": "Red&Blue Line Typo"
            },
            {
                "_id": "60a5ff400b1d7b003539d658",
                "name": "Refresh for me"
            }
        ]
    }
    fixedTemplates = {
        "병원/전문직": [
            {
                "_id": "6316a67d276bc30a16eccd47",
                "name": "Blue Medical promotion"
            },
            {
                "_id": "6466f797e14f0451ff48594d",
                "name": "Medical Center ad"
            },
            {
                "_id": "64be500d225b0348c991537c",
                "name": "Doctor's introduction"
            },
            {
                "_id": "64d5f61868b5e500574956c7",
                "name": "Icon Self Check List"
            },
			{
                "_id": "651400b86db59c282cceefd0",
                "name": "BlueGreen Dentist promotion "
            }
        ],
        "부동산": [
            {
                "_id": "61ca70e6f9eb0e054d3816b3",
                "name": "play button promo"
            },
            {
                "_id": "635b95dc260d3d220fe7911c",
                "name": "Blue&green realty ad"
            },
            {
                "_id": "635f5bbeb592d251401117ee",
                "name": "Gray real estate ad "
            },
            {
                "_id": "64df21e90d07ff005e5908e8",
                "name": "Orange line ad"
            },
            {
                "_id": "64f1c5619313be4d12fa4223",
                "name": "Message bubble real estate"
            }
        ],
        "뷰티": [
            {
                "_id": "5fc9de039ea3410034edb991",
                "name": "The videotape"
            },
            {
                "_id": "63c121f931a6b21c3b9dc529",
                "name": "Pink Delete Line ad"
            },
            {
                "_id": "64670652fe8e8e5218fb6777",
                "name": "Retro Colorful Typography"
            },
            {
                "_id": "6544b26d5774e20ac6f56447",
                "name": "Naviz beauty typography"
            },
            {
                "_id": "64d5f42f68b5e500574956ae",
                "name": "Nail product promotion"
            }
        ],
        "E커머스/쇼핑몰": [
            {
                "_id": "615fd42800211e04894a664b",
                "name": "Up & Down typo"
            },
            {
                "_id": "6188deae6a7dc50825d474b2",
                "name": "Colorful Pop-up Message"
            },
            {
                "_id": "61d7c700b6acec04441ac691",
                "name": "Blue Glitch Platform"
            },
            {
                "_id": "642b886d6ab49124a9b33821",
                "name": "Coupon and point"
            },
            {
                "_id": "64d08d10779b4d4149c6382c",
                "name": "Twinkle Gradation Line"
            }
        ],
        "숙박/여행/레저": [
            {
                "_id": "5f9bd45efd6e64002df47383",
                "name": "Colour Thunder Beam"
            },
            {
                "_id": "60decc23574615002c3f8aa4",
                "name": "neon makes it all better"
            },
            {
                "_id": "60f13a5a1fb57200330c32c6",
                "name": "capture the moment"
            },
            {
                "_id": "61fce688f04a440034a5bb6c",
                "name": "Coloric Kitsch"
            },
            {
                "_id": "648bd6fd08e13a0933c380f8",
                "name": "A website for summer festa"
            }
        ],
        "카페/음식/베이커리": [
            {
                "_id": "605af2567bb74c70d24bcd03",
                "name": "Our table"
            },
            {
                "_id": "60a7546f015b73002da3bf48",
                "name": "Sparkling story"
            },
            {
                "_id": "60a75cc2c5a89a0034102211",
                "name": "Introduce loudly"
            },
            {
                "_id": "60c2fb98aded4d00334404bc",
                "name": "what's your favorite juice?"
            },
            {
                "_id": "63c1223c31a6b21c3b9dc537",
                "name": "Purple heavy letter ad"
            }
        ],
        "패션": [
            {
                "_id": "60f4e4fa6fd7f7085db5188e",
                "name": "when retro meets pastel"
            },
            {
                "_id": "613aeb3c80a4f500adf4ddcd",
                "name": "Color snap"
            },
            {
                "_id": "620f24df048951002c4b0492",
                "name": "Vivid Brand ad"
            },
            {
                "_id": "6507b64eb3f1950374162775",
                "name": "Shop-B promotion"
            },
            {
                "_id": "6544bba41152370ad85c45f8",
                "name": "Graffiti Styling Lookbook"
            }
        ],
        "헬스/스포츠": [
            {
                "_id": "6094d6e3ea2d0c006b50cbe3",
                "name": "Challenge together"
            },
            {
                "_id": "636e0730ddc82f004ff0cb90",
                "name": "Electric dynamic typo"
            },
            {
                "_id": "65431b714566948d6a877978",
                "name": "Dynamic Gradient Typo"
            },
            {
                "_id": "65532fffd3b4df95a6aeb110",
                "name": "Color Circle Typo"
            },
            {
                "_id": "655efc01d013c52136a2fece",
                "name": "Red Power Fitness"
            }
        ]
    }

    handleClickFreeBtn = () => {
        this.props.history.push('/designselect')
    }

    render() {
        const categories = [
            { label: i18n.t("categoryfiltering.businesscategory.shopping mall_wholesale"), key: "E커머스/쇼핑몰" },
            { label: i18n.t("categoryfiltering.businesscategory.fashion"), key: "패션" },
            { label: i18n.t("categoryfiltering.businesscategory.beauty"), key: "뷰티" },
            { label: i18n.t("categoryfiltering.businesscategory.lodging_travel_leisure"), key: "숙박/여행/레저" },
            { label: i18n.t("categoryfiltering.businesscategory.cafe_food_bakery"), key: "카페/음식/베이커리" },
            { label: i18n.t("categoryfiltering.businesscategory.health_sports"), key: "헬스/스포츠" },
            { label: i18n.t("categoryfiltering.businesscategory.medical"), key: "병원/전문직" },
            { label: i18n.t("categoryfiltering.businesscategory.realestate"), key: "부동산" },
        ]

        const { lang, totalTemplateCount } = this.props
        const settings = {
            start: 0,
            count: totalTemplateCount,
            duration: 3000,
            animation: 'up',
        }
        return (
            <div className='new-templates-root-container'>
                {
                    lang === 'ko'
                        ?
                        <div className='heading-area'>
							<div className='count'><div><Trans i18nKey="web.newhome.template.section.title.ko"><AnimationCount {...settings}/></Trans></div></div>
                            <div className={`title ko`}>
                                {i18n.t("web.newhome.template.section.des")}
                            </div>
                        </div>
                        :
                        <div className='heading-area-en'>
                            <div className="title">
                                <Trans i18nKey="web.newhome.newtemplate.en.title">
                                    <span />
                                    <br />
                                </Trans>
                            </div>
                            <div className='des'>
                                <Trans i18nKey="web.newhome.newtemplate.en.des">
                                    <br />
                                </Trans>
                            </div>
                        </div>
                }
                <div className='template-wrap'>
                    {
                        lang === 'ko'
                            ?
                            null
                            :
                            <div className='background'></div>
                    }
                    <div className='template-area'>
                        {
                            categories.map(item => {
                                const isKo = lang === 'ko';
                                let targetTemplates = (isKo) ? this.fixedTemplates : this.fixedTemplatesEn;
                                const templates = targetTemplates[item.key]
                                const picked = (new Date().getHours()) % templates.length
                                const pickedTemplate = templates[picked]

                                const folderLang = isKo ? 'ko' : 'en'

                                // TO DO : 서버에서 직접 small video 가져오도록 수정
                                // 이전에 videomonster-renderer에서 small video 해상도 360p로 바꾸는 작업 선행 되어야함
                                return (
                                    <div className="video-container">
                                        <video
                                            src={
                                                isKo
                                                ? `https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/templates/${pickedTemplate._id}.mp4`
                                                : `https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/templates/${folderLang}/${pickedTemplate._id}.mp4`
                                            }
                                            autoPlay
                                            loop
                                            muted
                                            onClick={this.props.onThumbnailClicked(pickedTemplate._id)}
                                        />
                                        <div
                                            className='hastag'
                                            onClick={() => this.props.history.push(`/designselect?business_category=${item.key}`)}
                                        >
                                            {`#${item.label}`}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                {
                    lang === 'ko'
                        ?
                        <div className='setting-btn ko' onClick={this.handleClickFreeBtn}>
                            {i18n.t("web.newhome.template.section.button")}
                        </div>
                        :
                        <div className='setting-btn en' onClick={this.handleClickFreeBtn}>
                            {i18n.t("web.newhome.newtemplate.en.button")}
                        </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(TemplatesArea)